import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewOptions: {
		id: 'navigation-kit-tab-menu.view-options',
		defaultMessage: 'Tab options',
		description: 'Label of the button to open the pop up menu with the tab options.',
	},
	setAsDefaultView: {
		id: 'navigation-kit-tab-menu.set-as-default-item.set-as-default-view',
		defaultMessage: 'Set as default',
		description: 'Set as default view option in the tab navigation context menu.',
	},
	selected: {
		id: 'navigation-kit-tab-menu.set-as-default-item.selected',
		defaultMessage: 'Selected',
		description:
			'Label for icon that represents the selected state of the set as default view option in the tab navigation context menu.',
	},
	renameItem: {
		id: 'navigation-kit-tab-menu.rename-item.rename-item',
		defaultMessage: 'Rename',
		description: 'Rename view option in the tab navigation context menu.',
	},
	moveItemRight: {
		id: 'navigation-kit-tab-menu.move-item.move-item-right',
		defaultMessage: 'Move tab right',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab to the right.',
	},
	moveItemDown: {
		id: 'navigation-kit-tab-menu.move-item.move-item-down',
		defaultMessage: 'Move tab down',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab down.',
	},
	moveItemLeft: {
		id: 'navigation-kit-tab-menu.move-item.move-item-left',
		defaultMessage: 'Move tab left',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab to the left.',
	},
	moveItemUp: {
		id: 'navigation-kit-tab-menu.move-item.move-item-up',
		defaultMessage: 'Move tab up',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab up.',
	},
	hideItem: {
		id: 'navigation-kit-tab-menu.hide-item.hide-item',
		defaultMessage: 'Remove',
		description: 'Remove view option in the tab navigation context menu.',
	},
});
